export type Role = {
  _id: string;
  companyId: string;
  name: string;
  permissions: RolePermission[];
};

export enum DefaultRoles {
  OWNER = 'owner',
  ADMIN = 'admin',
  MANAGER = 'manager',
  EMPLOYEE = 'employee',
  cashier = 'cashier',
}

export type RolePermission = {
  name: string;
  value: boolean;
  permissionId: string;
  category: string;
  subCategory: string;
};

export type Permissions = {
  _id: string;
  name: string;
  label: string;
  value: boolean;
  category: string;
  subCategory: string;
};

export enum SubCategory {
  STORE_MANAGEMENT = 'store_management',
  BUILDER_ACCESS = 'builder_access',
  PAYMENTS = 'payments_access',
  GENERAL_ACTIONS = 'general_actions',
}

export enum RoleCategory {
  HUB_ACCESS = 'hub_access',
  STATION_ACCESS = 'station_access',
}

export enum PermissionName {
  BILLING = 'billing',
  ROLES = 'roles',
  PAYOUTS = 'payouts',
  OUTLETS = 'outlets',
  TAXES = 'taxes',
  GENERAL = 'general',
  USERS = 'users',
  SETTINGS = 'settings',
  STORE = 'store',
  PAYMENT = 'payment',
  ORDERS = 'orders',
  CUSTOMERS = 'customers',
  PRODUCTS = 'products',
  REPORTS = 'reports',
  STORE_SETTINGS = 'store_settings',
  BUILDER = 'builder',
  GLOBAL_BLOCKS = 'global_blocks',
  IMAGES = 'images',
  APP_STORE = 'app_store',
  DASHBOARD = 'dashboard',
  TRANSACTIONS = 'transactions',
  TERMINALS = 'terminals',
  PAYMENT_SETTINGS = 'payment_settings',
  GIVE_DISCOUNTS = 'give_discounts',
  ISSUE_REFUNDS = 'issue_refunds',
  DELETE_CUSTOMERS = 'delete_customers',
  ORGANIZATION = 'organization',
  PLANS = 'plans',
}
